<button type="button"
  class="me-3 w-[2.375rem] h-[2.375rem] inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-full border border-transparent text-white hover:bg-gray-100/10 disabled:opacity-50 disabled:pointer-events-none dark:text-white dark:hover:bg-neutral-700">
  <mat-icon class="material-icons-outlined">notifications</mat-icon>
</button>

<button (click)="toggleMenu()" clickOutside (clickOutside)="onClickedOutside()" type="button"
  class="w-[2.375rem] h-[2.375rem] inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-full border border-transparent text-white hover:bg-gray-100/10 disabled:opacity-50 disabled:pointer-events-none dark:text-white dark:hover:bg-neutral-700">
  <mat-icon class="material-icons-outlined">apps</mat-icon>
</button>

<!-- Dropdown -->
<div [@openClose]="isOpen ? 'open' : 'closed'"
  class="w-80 absolute right-0 z-20 mt-2 origin-top-right transform rounded-md bg-background shadow-custom ring-1 ring-transparent ring-opacity-5 transition focus:outline-none">
  <div class="flext-row flex items-center p-3">
    <div class="overflow-hidden px-2 text-sm font-semibold text-foreground">
      {{userLoginInfo.fullName}}
      <p class="truncate text-ellipsis text-xs font-semibold text-muted-foreground">{{userLoginInfo.email}}</p>
    </div>
  </div>

  <div class="border-b border-dashed border-border"></div>

  <div class="m-3">
    <span class="text-xs font-semibold text-foreground">{{'COMMON.LANGUAGE' | translate}}</span>
    <div class="mt-2 grid grid-cols-3 gap-2">
      @for (item of languages; track $index) {
      <div :key="$index" (click)="changeLanguage(item)"
        [ngClass]="{ 'border-muted-foreground bg-card': item.id == selectedLanguage }"
        class="focus-visible:ring-ring inline-flex h-8 cursor-pointer items-center justify-start whitespace-nowrap rounded-md border border-border bg-background px-3 text-xs font-medium text-muted-foreground shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 disabled:pointer-events-none disabled:opacity-50 hover:bg-card hover:text-foreground">
        <p class="capitalize">{{ item.name }}</p>
      </div>
      }
    </div>
  </div>

  <hr class="border-dashed border-border" />

  <div class="p-3 bg-[#fafafa]">
    <span class="text-xs font-semibold text-foreground">Applications</span>
    <div class="mt-2">
      @for (item of apps; track $index) {
      <a mat-stroked-button href="{{ item.link }}" target="_blank" class="!text-primary mt-2 ms-2 !font-semibold">
        <mat-icon>{{item.icon}}</mat-icon>
        {{item.name }}
      </a>
      }
    </div>
  </div>

  <hr class="border-dashed border-border" />

  <ul class="my-2 mx-4 flex flex-col">
    @for (item of profileMenu; track $index) {
    <li (click)="onClickMenuItem(item)" :key="$index" *ngIf="!item.hidden"
      class="inline-flex cursor-pointer items-center gap-2 rounded-md py-2 text-xs font-semibold text-muted-foreground hover:bg-card hover:text-primary">
      <svg-icon src="{{ item.icon }}" [svgClass]="'h-5 w-5 text-muted-foreground/50'"> </svg-icon>
      {{ item.title | translate }}
    </li>
    }
  </ul>

</div>